import { message } from 'antd'
import * as constants from '../constants'

const initialState = {
  notifications: {},
  filteredNotifications: [],
  filteredUserNotifications: [],
}

export function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications,
      }

    case constants.ADD_NOTIFICATION:
      message.info(`${action.notification.chargeBoxName} acionou o evento ${action.notification.type}`)
      return {
        ...state,
        notifications: { notificationList: [action.notification, ...state.notifications?.notificationList] },
      }

    case constants.ADD_FILTERED_NOTIFICATIONS:
      return {
        ...state,
        filteredNotifications: [{ chargeBoxId: action.chargeBoxId, notifications: action.notifications }, ...state.filteredNotifications],
      }

    case constants.ADD_FILTERED_NOTIFICATION:
      let filteredNotificationIndex = -1
      state.filteredNotifications.filter(({ chargeBoxId }, index) => {
        if (chargeBoxId === action.chargeBoxId) {
          filteredNotificationIndex = index
        }
        return chargeBoxId === action.chargeBoxId
      })

      if (filteredNotificationIndex > -1) {
        return {
          ...state,
          filteredNotifications: state.filteredNotifications.map((filteredNotification, i) => {
            if (filteredNotification.chargeBoxId === action.chargeBoxId) {
              return { ...filteredNotification, notifications: { notificationList: [action.notification, ...state.filteredNotifications[i]?.notifications?.notificationList] } }
            }
            return filteredNotification
          }),
        }
      } else {
        return {
          ...state,
        }
      }

    case constants.ADD_FILTERED_USER_NOTIFICATIONS:
      return {
        ...state,
        filteredUserNotifications: [{ userPk: action.userPk, notifications: action.notifications }, ...state.filteredUserNotifications],
      }

    case constants.ADD_FILTERED_USER_NOTIFICATION:
      let filteredUserNotificationIndex = -1
      state.filteredUserNotifications.filter(({ userPk }, index) => {
        if (userPk === action.userPk) {
          filteredUserNotificationIndex = index
        }
        return userPk === action.userPk
      })

      if (filteredUserNotificationIndex > -1) {
        return {
          ...state,
          filteredUserNotifications: state.filteredUserNotifications.map((filteredUserNotification, i) => {
            if (filteredUserNotification.userPk === action.userPk) {
              return { ...filteredUserNotification, notifications: { notificationList: [action.notification, ...state.filteredUserNotifications[i]?.notifications?.notificationList] } }
            }
            return filteredUserNotification
          }),
        }
      } else {
        return {
          ...state,
        }
      }

    default:
      return state
  }
}
